import { useDraggable as L } from "@vueuse/core";
import { defineComponent as O, ref as b, computed as n, toRef as _, watch as $, resolveComponent as N, openBlock as m, createElementBlock as d, normalizeClass as s, normalizeStyle as W, renderSlot as k, createElementVNode as D, createVNode as I, createCommentVNode as w } from "vue";
import { usePopoverState as j } from "@onereach/ui-components-common/hooks";
import { O as M } from "./OrIconButton-BlHCLpeW.mjs";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var c = /* @__PURE__ */ ((e) => (e.L = "l", e.M = "m", e.S = "s", e.None = "none", e))(c || {}), t = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e))(t || {});
const V = [
  // Layout
  "shrink-0",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark"
], q = {
  [t.Top]: [
    // Layout
    "layout-column"
  ],
  [t.Bottom]: [
    // Layout
    "layout-column-reverse"
  ],
  [t.Left]: [
    // Layout
    "layout-row !items-stretch",
    // Box
    "h-full min-h-0"
  ],
  [t.Right]: [
    // Layout
    "layout-row-reverse !items-stretch",
    // Box
    "h-full min-h-0"
  ]
}, A = [
  // Layout
  "layout-column grow",
  // Overflow
  "overflow-auto"
], F = {
  [c.L]: [
    // Spacing
    "px-lg",
    "py-lg"
  ],
  [c.M]: [
    // Spacing
    "px-md",
    "py-md"
  ],
  [c.S]: [
    // Spacing
    "px-sm",
    "py-sm"
  ],
  [c.None]: []
}, G = [], H = {
  [t.Top]: [
    // Box
    "h-[calc(theme(spacing.md)+theme(spacing.sm))]"
  ],
  [t.Bottom]: [
    // Box
    "h-[calc(theme(spacing.md)+theme(spacing.sm))]"
  ],
  [t.Left]: [
    // Box
    "w-[calc(theme(spacing.md)+theme(spacing.sm))]"
  ],
  [t.Right]: [
    // Box
    "w-[calc(theme(spacing.md)+theme(spacing.sm))]"
  ]
}, J = [
  // Position
  "relative",
  // Layout
  "shrink-0",
  // Layout (after)
  "after:block",
  // Theme (after)
  "after:border-outline-variant",
  "after:dark:border-outline-variant-dark",
  // Theme (after, hover)
  "after:hover:border-primary-hover",
  "after:dark:hover:border-primary-hover-dark",
  // Theme (after, activated)
  "after:activated:border-primary-hover",
  "after:dark:activated:border-primary-hover-dark"
], K = {
  [t.Top]: [
    // Layout
    "flex flex-col justify-center",
    // Interactivity
    "interactivity-resize-row",
    // Spacing
    "-my-[calc(theme(spacing.md)/2)]",
    "py-[calc(theme(spacing.md)/2)]",
    // Theme (after)
    "after:border-b-1"
  ],
  [t.Bottom]: [
    // Layout
    "flex flex-col justify-center",
    // Interactivity
    "interactivity-resize-row",
    // Spacing
    "-my-[calc(theme(spacing.md)/2)]",
    "py-[calc(theme(spacing.md)/2)]",
    // Theme (after)
    "after:border-t-1"
  ],
  [t.Left]: [
    // Layout
    "flex flex-row justify-center",
    // Interactivity
    "interactivity-resize-column",
    // Spacing
    "-mx-[calc(theme(spacing.md)/2)]",
    "px-[calc(theme(spacing.md)/2)]",
    // Theme (after)
    "after:border-r-1"
  ],
  [t.Right]: [
    // Layout
    "flex flex-row justify-center",
    // Interactivity
    "interactivity-resize-column",
    // Spacing
    "-mx-[calc(theme(spacing.md)/2)]",
    "px-[calc(theme(spacing.md)/2)]",
    // Theme (after)
    "after:border-l-1"
  ]
}, Q = [
  // Position
  "absolute",
  // Shape
  "rounded-full",
  // Box
  "w-fit",
  "h-fit",
  // Typography
  "leading-[0]",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-border-outline-variant border-1",
  "dark:theme-border-outline-variant-dark"
], U = {
  [t.Top]: [
    // Position
    "left-md"
  ],
  [t.Bottom]: [
    // Position
    "left-md"
  ],
  [t.Left]: [
    // Position
    "top-md"
  ],
  [t.Right]: [
    // Position
    "top-md"
  ]
}, X = [
  // Layout
  "shrink-0",
  // Overflow
  "overflow-auto",
  // Spacing
  "px-md",
  "py-md",
  "gap-md",
  // Theme
  "theme-border-outline-variant border-1",
  "dark:theme-border-outline-variant-dark"
], Y = {
  [t.Top]: [
    // Layout
    "layout-row",
    // Theme
    "!border-t-0",
    "!border-x-0"
  ],
  [t.Bottom]: [
    // Layout
    "layout-row",
    // Theme
    "!border-b-0",
    "!border-x-0"
  ],
  [t.Left]: [
    // Layout
    "layout-column",
    // Theme
    "!border-l-0",
    "!border-y-0"
  ],
  [t.Right]: [
    // Layout
    "layout-column",
    // Theme
    "!border-r-0",
    "!border-y-0"
  ]
}, Z = O({
  name: "OrResizeablePanel",
  components: {
    OrIconButton: M
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !0
    },
    width: {
      type: Number,
      default: 320
    },
    minWidth: {
      type: Number,
      default: 256
    },
    maxWidth: {
      type: Number,
      default: 384
    },
    padding: {
      type: String,
      default: () => c.M
    },
    placement: {
      type: String,
      default: () => t.Right
    },
    resizeable: {
      type: Boolean,
      default: !0
    },
    collapsible: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:state",
    "open",
    "close",
    "resize"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, i) {
    const y = b(), f = b(), p = n(() => [
      "or-resizeable-panel-v3",
      ...V,
      ...q[e.placement]
    ]), g = n(() => [
      ...A,
      ...F[e.padding]
    ]), h = n(() => [
      ...G,
      ...H[e.placement]
    ]), v = n(() => [
      ...J,
      ...K[e.placement],
      ...!e.resizeable || e.collapsible && u.value === "closed" ? ["interactivity-none"] : []
    ]), z = n(() => [
      ...Q,
      ...U[e.placement]
    ]), B = n(() => [
      ...X,
      ...Y[e.placement]
    ]), { state: u, open: S, close: R, toggle: C } = j(_(e, "isOpen"), i.emit), P = n(() => {
      if (u.value === "open")
        switch (e.placement) {
          case t.Top:
            return "keyboard_arrow_up";
          case t.Bottom:
            return "keyboard_arrow_down";
          case t.Left:
            return "keyboard_arrow_left";
          case t.Right:
            return "keyboard_arrow_right";
        }
      if (u.value === "closed")
        switch (e.placement) {
          case t.Top:
            return "keyboard_arrow_down";
          case t.Bottom:
            return "keyboard_arrow_up";
          case t.Left:
            return "keyboard_arrow_right";
          case t.Right:
            return "keyboard_arrow_left";
        }
      return "menu";
    }), x = n(() => {
      switch (e.placement) {
        case t.Top:
        case t.Bottom:
          return "height";
      }
      return "width";
    }), l = b(e.width);
    $(() => e.width, (a) => {
      l.value = a;
    });
    let o = 0;
    const { isDragging: T } = L(f, {
      onStart: (a, r) => {
        if (e.resizeable) {
          switch (e.placement) {
            case t.Top:
            case t.Bottom:
              o = r.y;
              break;
            case t.Left:
            case t.Right:
              o = r.x;
              break;
          }
          document.body.style.userSelect = "none";
        }
      },
      onMove: (a) => {
        if (e.resizeable) {
          let r = 0;
          switch (e.placement) {
            case t.Top:
              r = l.value + (a.y - o), o = a.y;
              break;
            case t.Bottom:
              r = l.value + (o - a.y), o = a.y;
              break;
            case t.Left:
              r = l.value + (a.x - o), o = a.x;
              break;
            case t.Right:
              r = l.value + (o - a.x), o = a.x;
              break;
          }
          r < e.minWidth && (r = e.minWidth), r > e.maxWidth && (r = e.maxWidth), r !== l.value && i.emit("resize", l.value = r);
        }
      },
      onEnd: () => {
        e.resizeable && (document.body.style.userSelect = "");
      }
    });
    return {
      root: y,
      resizeBar: f,
      rootStyles: p,
      contentStyles: g,
      contentPlaceholderStyles: h,
      resizeBarStyles: v,
      collapseButtonContainerStyles: z,
      toolbarStyles: B,
      state: u,
      open: S,
      close: R,
      toggle: C,
      collapseButtonIcon: P,
      currentDirection: x,
      currentSize: l,
      isDragging: T
    };
  }
}), ee = ["activated"];
function te(e, i, y, f, p, g) {
  const h = N("OrIconButton");
  return m(), d("div", {
    ref: "root",
    class: s(e.rootStyles),
    style: W({ [e.currentDirection]: !e.collapsible || e.state === "open" ? `${e.currentSize}px` : "auto" })
  }, [
    !e.collapsible || e.state === "open" ? (m(), d("div", {
      key: 0,
      class: s(e.contentStyles)
    }, [
      k(e.$slots, "default")
    ], 2)) : (m(), d("div", {
      key: 1,
      class: s(e.contentPlaceholderStyles)
    }, null, 2)),
    D("div", {
      ref: "resizeBar",
      class: s(e.resizeBarStyles),
      activated: e.isDragging
    }, [
      e.collapsible ? (m(), d("div", {
        key: 0,
        class: s(e.collapseButtonContainerStyles)
      }, [
        I(h, {
          "additional-styles": ["p-xs"],
          icon: e.collapseButtonIcon,
          color: "primary",
          size: "m",
          onClick: i[0] || (i[0] = (v) => e.toggle())
        }, null, 8, ["icon"])
      ], 2)) : w("", !0)
    ], 10, ee),
    e.$slots.toolbar ? (m(), d("div", {
      key: 2,
      class: s(e.toolbarStyles)
    }, [
      k(e.$slots, "toolbar")
    ], 2)) : w("", !0)
  ], 6);
}
const se = /* @__PURE__ */ E(Z, [["render", te]]);
export {
  se as O,
  c as R,
  t as a
};
//# sourceMappingURL=OrResizeablePanel-DuGgwmhB.mjs.map
